/* eslint no-console: 0 */

import Vue from 'vue'
import VuePlyr from "vue-plyr"
import store from '../audio/store'
import router from '../audio/routes'

import '../stylesheets/tailwind'
import "vue-plyr/dist/vue-plyr.css"

Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: false },
  },
  emit: ["ended"],
});

import App from '../audio/app.vue'

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    el: '#audio',
    store,
    router,
    render: h => h(App)
  })
  // console.log(app)
})

